import {
  put, takeLatest, takeEvery, select, all,
} from 'redux-saga/effects';
import {
  TeammoApi,
  normalize,
  compilePaginationObject,
} from 'app/utils/redux/helpers';
import { seasonSchema, seasonListSchema } from 'app/utils/redux/schemas';
import { handleError } from 'app/utils/handlers/handleError';
import {
  loadingStart,
  loadingFinish,
  actionConfirmed,
} from 'app/ducks/loading/actions';
import {
  sagaActions,
} from 'app/ducks/seasons/actions';
import { SeasonsActionTypes as types } from 'app/ducks/seasons/types';

function* createSeasonSaga(action): any {
  yield put(sagaActions.createSeasonPending(action.payload));
  const [error, response] = yield (yield TeammoApi(yield select())).teamSeasons.create(
    action.payload,
  );

  if (response) {
    const normalizedResponse = normalize(response, seasonSchema);

    yield put(sagaActions.createSeasonSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.createSeasonFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* updateSeasonSaga(action): any {
  yield put(sagaActions.updateSeasonPending(action.payload));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).teamSeasons.update(action.payload);

  if (response) {
    const normalizedResponse = normalize(response, seasonSchema);

    yield put(sagaActions.updateSeasonSuccess(normalizedResponse));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.updateSeasonFailed(_.isEmpty(error) ? {} : error.response.data.errors),
      ),
    );
  }
}

function* deleteSeasonSaga(action): any {
  yield put(sagaActions.deleteSeasonPending(action.payload.id));
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).teamSeasons.delete(action.payload);

  if (response || _.isEmpty(error)) {
    // const normalizedResponse = normalize(response, seasonSchema);
    yield put(actionConfirmed('Team member deleted'));
    yield put(sagaActions.deleteSeasonSuccess(action.payload.id));
  } else {
    yield put(
      handleError(
        error,
        sagaActions.deleteSeasonFailed(
          _.isEmpty(error) ? {} : error.response.data.errors,
        ),
      ),
    );
  }
}

function* getSeasonSaga(action): any {
  yield put(sagaActions.getSeasonPending());
  const [error, response] = yield (
    yield TeammoApi(yield select())
  ).teamSeasons.show(action.payload);
  if (response) {
    const normalizedResponse = normalize(response, seasonSchema);
    yield put(sagaActions.getSeasonSuccess(normalizedResponse));
    return normalizedResponse.entities.seasons[normalizedResponse.result];
  }
  yield put(
    handleError(error, sagaActions.getSeasonFailed(_.isEmpty(error) ? {} : error.response.data.errors)),
  );
  return null;
}

function* getAllSeasonsSaga(action): any {
  yield put(
    sagaActions.getAllSeasonsPending(action.payload.compile ? action.payload.pagination : {}),
  );
  yield put(loadingStart());

  const paginationObject = action.payload.compile
    ? compilePaginationObject(yield select((state) => state.seasons.pagination))
    : action.payload.pagination;
  const teammoApi = TeammoApi(yield select());

  const [error, response] = yield (yield teammoApi).teamSeasons.list(
    paginationObject,
  );

  if (response) {
    const normalizedResponse = normalize(response, seasonListSchema);

    yield put(
      sagaActions.getAllSeasonsSuccess(normalizedResponse, response.meta),
    );
    yield put(loadingFinish());
  } else {
    yield put(error, sagaActions.getAllSeasonsFailed(_.isEmpty(error) ? {} : error.response.data.errors));
  }
}

/* ********************************* SAGA WATCHERS ********************************* */

function* createSeasonSagaWatcher(): any {
  yield takeLatest(types.CREATE_TEAM_MEMBER_REQUESTED, createSeasonSaga);
}

function* updateSeasonSagaWatcher(): any {
  yield takeLatest(types.UPDATE_TEAM_MEMBER_REQUESTED, updateSeasonSaga);
}

function* deleteSeasonSagaWatcher(): any {
  yield takeLatest(types.DELETE_TEAM_MEMBER_REQUESTED, deleteSeasonSaga);
}

function* getSeasonSagaWatcher(): any {
  yield takeLatest(types.GET_TEAM_MEMBER_REQUESTED, getSeasonSaga);
}

function* getAllSeasonsSagaWatcher(): any {
  yield takeLatest(types.GET_ALL_TEAM_MEMBERS_REQUESTED, getAllSeasonsSaga);
}

export default function* root(): any {
  yield all([
    createSeasonSagaWatcher(),
    updateSeasonSagaWatcher(),
    deleteSeasonSagaWatcher(),
    getSeasonSagaWatcher(),
    getAllSeasonsSagaWatcher(),
  ]);
}
